























































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { getIsBook } from '~/utils/solepro/products';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { productBuyCTATrack } from '~/helpers/trackings/24orepro/products';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import { manageScroll } from '~/utils/helpers/functions';

export default defineComponent({
    props:{
        product:{
            type: Object as PropType<ProductForProductPageType>
        }
    },
    setup(props){
        const hasAddictionalProducts = props.product.additionalProducts && props.product.additionalProducts.length>0
        const hasSomeBuyable = props.product.additionalProducts && props.product.additionalProducts.length>0 
        && props.product.additionalProducts.some(p=>p.buyable);

        
        const ctas = props.product.area_cta;
        const ctasObj = !!ctas ? getAsJSON(ctas): null;
        return {
            ctasObj,
            isBook: getIsBook(props.product),
            hasAddictionalProducts,
            hasSomeBuyable
        }
    },
    data(){
        return {
            editorialStickyBtn: null
        }
    },
    methods:{
        async manageScroll(evt, isEditorialBtnClick){
            evt.preventDefault();
            if(isEditorialBtnClick && this.editorialStickyBtn){
                const splitted = (this.editorialStickyBtn?.href || '').split('#');
                if(splitted[1]){
                    manageScroll(evt)
                    await productBuyCTATrack(this.product, this.editorialStickyBtn.innerText);
                }else {
                    return
                }
            }else{
                manageScroll(evt)
                await productBuyCTATrack(this.product, evt.currentTarget.innerText);
            }
        },
        checkElements(){
            document.querySelectorAll('[id^=sticky__]').forEach(el=>{
                const id = el.id.split('__')[1];
                if(!document.getElementById(id)){
                    el.classList.add('hidden')
                }else{
                    el.classList.remove('hidden')
                }
            })
        }
       
    },
    mounted(){
        /** @TODO do this check on custom state change on specific components to keep always reactive this bar */
        this.checkElements()
        const interval = setInterval(()=>{
            this.checkElements()
        },200)
        setTimeout(()=>{
            clearInterval(interval)
        },10000)

        try{
           this.editorialStickyBtn = this.ctasObj ? this.ctasObj.children[0].children[0].children.find(btn=>btn.cssClasses.includes('pdp-sticky')).DOMContent.children[0] : null; 
        }catch(e){
            console.warn('/** no sticky b tn choosen from area_cta */')
            /** no sticky btn choosen from area_cta */
        }
    }
})
